<template>
  <div>
    <!-- {{mapLegend}} -->
    <v-cal-tbl-map
      :eventClick="eventClick"
      :eventTemplate="eventTemplate"
      :getItemColor="getItemColor"
      :coloredFields="['status']"
      :tableKey="tableKey"
      :onDataReceived="onDataReceived"
      :activeTab="activeTab"
      :noDelete="true"
      ref="calTblMap"
      :linkClick="linkClick"
      :link="link"
      :mapTitle="mapTitle"
      :mapReady="mapReady"
      :mapData="mapData"
      :mapLegend="mapLegend"
      :editable="editable"
      :onMarkerClick="onMarkerClick"
      :showGroupBy="true"
      :dateField="dateField"
      :getDataObject="getDataObject"
      :defaultEventColor="defaultEventColor"
      :updateTable="updateTable"
      :activeTabChanged="activeTabChanged"
      :mapLoading="mapLoading"
      :mapRefresh="mapRefresh"
      :createRouteData="createRouteData"
      :tableName="tableName"
    >
    </v-cal-tbl-map>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";

export default {
  name: "LocalDispatch",
  components: {
    VCalTblMap: () => import("../components/CalTblMap.vue"),
  },
  props: {},
  data() {
    return {
      mapTitle: "Service Map",
      tableName: "localdispatch",
      defaultEventColor: "#137C15FF",
      data_object: null,
      // activeTab: 0,
      dateField: "date",
      crewTemplate:
        "var s='';  if(r.crew && r.crew.crew && r.crew.truck) {r.crew.crew.forEach((c)=>{s+='&#128589; '+c.role+': '+c.helper.full_name+'<br>'});r.crew.truck.forEach((c)=>{s+='&#128666; '+c.name+'<br>'})} else { s='No Crew Assigned' }; s",
      link: {
        field: "shipment_id",
        name: "shipment",
      },
      mapData: [],
      mapLegend: {
        data_object: {
          object_name: "v_foreman",
          get_table: "all",
        },
        editable: ["crew"],
        getFreshData: true,
        mobileBreakpoint: 0,
        foreman: [],
        status: [],
        all_records: true,
        table_title: "Foreman",
        tableName: "foreman",
        hasSearch: true,
        fields_included: ["full_name", "crew"],
        noTabs: true,
        hideHeader: false,
        singleSelect: true,
        coloredFields: ["full_name"],
        getItemColor: function(e, slot, item, tableName) {
          // console.log(e, slot, item, tableName);
          return item.color;
        },
        width: 4,
        onDataReceived: this.mapLegendDataReceived,
      },
      editable: ["foreman", "status"],
      model: [],
      mapLoading: false,
      mapRefresh: 0,
      serviceDate: "",
      timeSlots: {
        morning: { start: 6, end: 12 },
        afternoon: { start: 12, end: 18 },
        evening: { start: 18, end: 24 },
      },
    };
  },
  computed: {
    crewWithForemanTemplate() {
      return this.crewTemplate.replace(
        "var s=''",
        "var s='&#128114; foreman:'+r.full_name+' <br>'"
      );
    },
  },
  mounted() {
    this.getDataObject();
  },
  beforeDestroy() {},
  methods: {
    mapLegendDataReceived(d) {
      d.schema.properties.crew.template = this.crewTemplate;

      return d;
    },
    createRouteData(qry, dayData) {
      this.mapData = [];
      var that = this;
      // var qry = this.$refs.calTblMap.data_object.qry;

      var data_object = {
        object_name: "v_route",
        get_table: "all",
        date_fields: ["date"],
        qry: qry,
      };
      axios
        .post(this.serverURL + "/get_data", data_object, {
          withCredentials: true,
        })
        .then((response) => {
          var routeData = response.data;
          // var clonedData = fun.clone(routeData);
          dayData.forEach((d) => {
            var rData = [];
            rData = routeData.model.filter((r) => {
              return r._id == d._id;
            })[0];
            if (rData) {
              d.route = rData.route;
              d.foreman = rData.foreman;
            }
          });

          dayData.forEach((e) => {
            if (!e.route || !e.route.length) {
              this.$refs.calTblMap.mapLoading = true;
              this.calculateJobRoute(e);
            } else {
              this.createMapData(e);
            }
          });
          // this.$root.$emit("mapDataChanged", {
          //   data: this.mapData,
          //   legend: this.mapLegend,
          // });
          this.mapReady = true;

          // this.mapRefresh = !this.mapRefresh;
        });
    },
    activeTabChanged(tab) {
      // if (tab == 2) {
      //   console.log("map");
      // }
    },
    updateMapData(t) {
      var mapIndex = -1;
      this.mapData.forEach((m, i) => {
        m.waypoints.forEach((w) => {
          if (w.shipment_id == t.item.shipment_id) {
            mapIndex = i;
            // var color = this.getItemColor(t.item, "foreman");
            // console.log(m);
          }
        });
      });
      this.mapData.splice(mapIndex, 1);
      this.createMapData(t.item);
    },
    updateTable(t, f) {
      var data = {
        collection: "schedule",
        qry: {
          _id: t.item._id,
        },
        update: {
          foreman: t.item.foreman,
          status: t.item.status,
        },
      };
      axios
        .post(this.serverURL + "/modify_value", data, {
          withCredentials: true,
        })
        .then((r) => {
          if (f) {
            f(r);
          }
        });
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },

    getItemColor(e, slot, item, tableName) {
      var color = "";
      switch (slot) {
        case "status":
          if (e) {
            color = this.status.filter((f) => {
              return f.status == e;
            })[0].color;
          }
          break;
        case "foreman":
          if (e) {
            var frm = this.foreman.filter((f) => {
              return f._id == e._id;
            })[0];
            if (frm) {
              color = frm.color;
            }
          }

          break;
        default:
          break;
      }
      return color;
    },
    eventTemplate: function(e, data, obj) {
      var color = "";
      if (e.status) {
        try {
          color = this.status.filter((f) => {
            return f.status == e.status;
          })[0].color;
        } catch (error) {
          //
        }
      }
      var endTime = new Date(e.date).addHours(3);
      var ev = {
        name:
          e.shipment_id +
          " " +
          e.customer.contact.first_name +
          " " +
          e.customer.contact.last_name,
        start: e.date,
        end: endTime,
        shipment_id: e.shipment_id,
        first_name: e.customer.contact.first_name,
        last_name: e.customer.contact.last_name,
        // estimator: e.estimator,
        color: color ? color : "",
        // end: fun.formatDateTime(endTime),
        timed: true,
      };

      return ev;
    },

    getDataObject(tbl) {
      var data_object = {
        object_name: "v_schedule",

        date_fields: ["date"],
        mobileBreakpoint: 0,
        table_title: "Local Schedule",
        // qry: {
        //   first_itinerary_step: "d2d",
        // },
        hasSearch: true,
        additional_data: [
          { obj_name: "v_foreman" },
          { obj_name: "order_status" },
        ],
      };

      return data_object;
    },

    onMarkerClick(data, e) {
      var topElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-top")[0];
      var innerElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-inner")[0];

      var unassign = false;
      var msg = "";

      if (
        data.legend.selected[0] &&
        topElement.innerHTML == data.legend.selected[0].employee_id
      ) {
        unassign = true;
      }
      msg =
        "Confirm assigning " +
        data.legend.selected[0].full_name +
        " to #" +
        data.shipment_id +
        "?";

      if (unassign) {
        msg = "Confirm unassigning #" + data.shipment_id + "?";
      }

      // this.$root.$confirm
      //   .open("Confirmation", msg, {
      //     color: "green",
      //   })
      //   .then((confirm) => {
      //     if (confirm) {
      data.item.foreman = {
        _id: data.legend.selected[0]._id,
        full_name: data.legend.selected[0].full_name,
        crew: data.legend.selected[0].crew || {},
      };
      data.item.foreman_name = data.legend.selected[0].full_name;
      this.updateTable(data, (resp) => {
        innerElement.style.backgroundColor = data.legend.selected[0].color;
        this.updateMapData(data);
        // this.$refs.calTblMap.refresh();
        // this.mapRefresh = !this.mapRefresh;

        // this.mapData.filter((m) => {
        //   return m.waypoints[0].item._id == data.item._id;
        // })[0].waypoints[0].item.foreman = data.item.foreman;
        // this.tableKey = !this.tableKey;
        // this.mapRefresh = !this.mapRefresh;
        // this.$root.$emit("mapDataChanged", {
        //   data: this.mapData,
        //   legend: this.mapLegend,
        // });
      });
      // }
      // });
    },
    eventClick(e) {
      this.linkClick(e.event);
    },
    // mapRefresh() {
    //   this.$root.$emit("mapDataChanged", {
    //     data: this.mapData,
    //     legend: this.mapLegend,
    //   });
    //   this.mapReady = true;
    // },
    calculateRoute(model, fn) {
      this.mapLoading = true;
      axios
        .post(this.serverURL + "/get_route", model, {
          withCredentials: true,
        })
        .then((response) => {
          fn(response.data);
        })
        .catch((reason) => {
          this.mapLoading = false;
          console.log(reason);
        });
    },
    calculateJobRoute(e, feedback) {
      var that = this;
      var shipment = fun.clone(e);

      var data = {
        waypoints: [],
      };
      e.stops.forEach((a) => {
        var position = fun.getObjectByKey(a, "position");
        if (position) {
          var pos = {
            lat: position[0],
            lng: position[1],
          };
          data.waypoints.push(pos.lat + "," + pos.lng);
        }
      });

      that.calculateRoute(data, (r) => {
        if (!r) {
          return;
        }
        // t.tbl.customBtnLoading = false;
        var routeData = [];
        routeData.push({
          mapLine: {
            service: {
              route: r[0],
            },
            //
          },
          waypoints: data.waypoints,
        });
        var route = {
          metadata: {
            object_name: "schedule",
          },
          model: {
            _id: e._id,
            route: routeData,
            service_date: this.serviceDate,
          },
        };
        shipment.route = routeData;

        axios
          .post(this.serverURL + "/add_data", route, {
            withCredentials: true,
          })

          .then((response) => {
            this.createMapData(shipment);
            // this.mapRefresh = !this.mapRefresh;
            // this.$root.$emit("mapDataChanged", {
            //   data: this.mapData,
            //   legend: this.mapLegend,
            // });
            // this.mapReady = true;
            // console.log(response);
          });

        // feedback();
      });
    },
    createMapData(e) {
      var wayPointData = [];

      var foreman = this.foreman.filter((f) => {
        return e.foreman ? e.foreman._id == f._id : false;
      })[0];

      var customer_name = e.first_name + " " + e.last_name;
      e.stops.forEach((a) => {
        var position = fun.getObjectByKey(a, "position");
        //a.location.location.address.geo.location.position;
        var pos = {
          lat: position[0],
          lng: position[1],
        };
        var addressType = a.value;
        var crewInfo = "";
        var r = e.foreman;
        try {
          crewInfo =
            "<br>Crew:<div style='text-align:left'>" +
            eval(this.crewWithForemanTemplate) +
            "</div>";
        } catch (error) {
          console.log(error);
        }

        wayPointData.push({
          pos: pos,
          shipment_id: e.shipment_id,
          item: e,
          label:
            customer_name +
            " " +
            fun.formattedDateTime(e.date) +
            " #" +
            e.shipment_id +
            " " +
            crewInfo,
          // address: pickup,
          shortLabel:
            addressType == "pickup"
              ? fun.formatTime(e.date, true)
              : '<div class="mdi mdi-flag-checkered"></div>',
          // extraClass: addressType == "origin" ? ["romb"] : ["square"],
          // shortLabel: '<div class="mdi mdi-home"></div>',
          markerColor: foreman ? foreman.color : "",
        });
      });
      var mapLine = fun.clone(e.route[0]) || {};

      mapLine.waypoints = wayPointData;
      mapLine.color = foreman ? foreman.color : "";
      this.mapData.push(mapLine);
      this.$root.$emit("mapDataChanged", {
        data: this.mapData,
        legend: this.mapLegend,
      });
      this.$refs.calTblMap.mapLoading = false;
      this.mapReady = true;
    },

    onDataReceived(data, d) {
      // console.log(data);

      this.mapReady = false;
      this.foreman = data.additional_model.v_foreman;
      this.status = data.additional_model.order_status;
      this.model = fun.clone(data.model);
      // if (tbl) {
      //   this.createRouteData();
      // }

      if (d) {
        // if (!data.table.length) {
        //   data.table = data.model;
        // }
        data.schema.properties.foreman.template =
          "r=r.foreman; " + this.crewWithForemanTemplate;

        this.serviceDate = fun.getFullDate(d);
        data.table = data.model.filter((m) => {
          return fun.getFullDate(new Date(m.date)) == this.serviceDate;
        });

        this.dataTable = data.table;
        this.dataTable.forEach((e) => {
          // if (!tbl) {
          e.first_name = e.customer.contact.first_name;
          e.last_name = e.customer.contact.last_name;
          var customer_name =
            e.customer.contact.first_name + " " + e.customer.contact.last_name;
          // }

          if (!e.status) {
            e.status = "scheduled";
          } else {
            // console.log(e);
          }

          // if (d) {
          if (e.foreman) {
            e.foreman_name = e.foreman.full_name;
          }

          // e.customer = customer_name;
        });

        return data.table;
      } else {
        return data.table;
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
